module.exports = __webpack_public_path__ + "static/media/whatsapp-active.9f699540.svg";